import React from "react";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { ReportIssueSection } from "@/components/sections/ReportIssueSection";

export default function ReportIssuePage() {
  return (
    <main>
      <PageHeader eyebrow="Report" title="Report a community issue." lead="Your report, our follow-through. CAF partners with local authorities to escalate valid reports." />
      <ReportIssueSection />
    </main>
  );
}
